"use client";
import { ikp as o } from "../../components/factory.js";
import { LinkWithQueryParams as d } from "../link.js";
const e = o("h1", {
  _id: "markdownH1"
}), i = o("h2", {
  _id: "markdownH2"
}), c = o("p", {
  _id: "markdownP"
}), k = o("li", {
  _id: "markdownLi"
}), t = o("ul", {
  _id: "markdownUl"
}), a = o("ol", {
  _id: "markdownOl"
}), l = o(d, {
  _id: "markdownLink"
}), w = o("sup", {
  _id: "markdownSourceLink"
}), s = o("table", {
  _id: "markdownTable"
}), _ = o("th", {
  _id: "markdownTh"
}), b = o("td", {
  _id: "markdownTd"
}), m = o("code", {
  _id: "markdownCode"
}), p = o("div", {
  _id: "codeblockContainer"
}), u = o("div", {
  _id: "codeblockHeader"
}), C = o("span", {
  _id: "codeblockHeaderLanguage"
}), h = o("button", {
  _id: "codeblockCopyButton",
  type: "button"
}), M = o("div", {
  _id: "codeblockHighlighterWrapper"
}), g = o("div", {
  _id: "codeblockHighlighter"
}), H = o("code", {
  _id: "codeblockCode"
}), L = o("input", {
  _id: "markdownInput"
});
export {
  H as CodeblockCode,
  p as CodeblockContainer,
  h as CodeblockCopyButton,
  u as CodeblockHeader,
  C as CodeblockHeaderLanguage,
  g as CodeblockHighlighter,
  M as CodeblockHighlighterWrapper,
  m as MarkdownCode,
  e as MarkdownH1,
  i as MarkdownH2,
  L as MarkdownInput,
  k as MarkdownLi,
  l as MarkdownLink,
  a as MarkdownOl,
  c as MarkdownP,
  w as MarkdownSourceLink,
  s as MarkdownTable,
  b as MarkdownTd,
  _ as MarkdownTh,
  t as MarkdownUl
};
